module.exports = __webpack_public_path__ + "static/Front5_Cropped-f4d725cb309c9792dc533c0289200f07.jpg";